(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2628],{

/***/ 70930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ LOCATIONS; },
/* harmony export */   "ZY": function() { return /* binding */ ALL_LOCATIONS; },
/* harmony export */   "g6": function() { return /* binding */ ALL_AUSTRALIA; },
/* harmony export */   "rb": function() { return /* binding */ ALL_NEW_ZEALAND; }
/* harmony export */ });
/* unused harmony exports LOCATIONS_VALUE_TO_LABEL_MAP, LOCATIONS_LABEL_TO_VALUE_MAP */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var ALL_LOCATIONS = "All Locations";
var ALL_AUSTRALIA = "All Australia";
var ALL_NEW_ZEALAND = "All New Zealand";
var _obj;
var LOCATIONS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ALL_LOCATIONS, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ALL_AUSTRALIA, [
    {
        label: "Australian Capital Territory",
        value: "Australian Capital Territory"
    },
    {
        label: "New South Wales",
        value: "New South Wales"
    },
    {
        label: "Northern Territory",
        value: "Northern Territory"
    },
    {
        label: "Queensland",
        value: "Queensland"
    },
    {
        label: "South Australia",
        value: "South Australia"
    },
    {
        label: "Victoria",
        value: "Victoria"
    },
    {
        label: "Tasmania",
        value: "Tasmania"
    },
    {
        label: "Western Australia",
        value: "Western Australia"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, ALL_NEW_ZEALAND, [
    {
        label: "North Island",
        value: "NZ North Island"
    },
    {
        label: "South Island",
        value: "NZ South Island"
    }, 
]), _obj);
var LOCATIONS_VALUE_TO_LABEL_MAP = new Map(Object.values(LOCATIONS).flat().map(function(i) {
    return [
        i.value,
        i.label
    ];
}));
var LOCATIONS_LABEL_TO_VALUE_MAP = new Map(Object.values(LOCATIONS).flat().map(function(i) {
    return [
        i.label,
        i.value
    ];
}));


/***/ }),

/***/ 53813:
/***/ (function() {



/***/ }),

/***/ 78219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ disableWeekends; },
/* harmony export */   "PN": function() { return /* binding */ parseAndFormatDate; },
/* harmony export */   "Zv": function() { return /* binding */ isSameOrBeforeCurrentDate; },
/* harmony export */   "e3": function() { return /* binding */ toIsoDateString; },
/* harmony export */   "i$": function() { return /* binding */ isWeekendDate; },
/* harmony export */   "iT": function() { return /* binding */ saleforceDateFormat; },
/* harmony export */   "qb": function() { return /* binding */ isValidDate; },
/* harmony export */   "sL": function() { return /* binding */ getTomorrow; }
/* harmony export */ });
/* unused harmony export isBeforeNow */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__);

// the customParseFormat is required for strict validation


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default()));
var isBeforeNow = function(dateTime) {
    var now = dayjs(new Date());
    return dayjs(dateTime).add(1, "day").isBefore(now);
};
var saleforceDateFormat = function(date) {
    return Intl.DateTimeFormat("en-NZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(date);
};
var toIsoDateString = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).toISOString();
};
var getTomorrow = function() {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "day");
};
/**
 * Performs a strict date validation against a given format
 * Checks if date is actually a valid one and in the right format
 */ var isValidDate = function(date, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, format, true).isValid();
};
/**
 * Converts an ISO date to given format
 * ! Will try to convert even invalid dates using native 'Date' object rules
 * For example '2022-02-31' will be converted to '2022-03-03'
 */ var parseAndFormatDate = function(dateToParse, format) {
    if (!dateToParse) {
        return null;
    }
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateToParse);
    return dayjsDate.isValid() ? dayjsDate.format(format) : null;
};
//Identify weekends
var disableWeekends = function(date) {
    if (date && (date.getDay() == 0 || date.getDay() === 6)) {
        return true;
    }
    return false;
};
var isSameOrBeforeCurrentDate = function(date) {
    var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(new Date());
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isSameOrBefore(now);
};
var isWeekendDate = function(date) {
    var day = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).day();
    return day === 0 || day === 6;
};


/***/ }),

/***/ 92628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S4": function() { return /* binding */ purgeQuery; },
/* harmony export */   "WC": function() { return /* binding */ generateLocationInfo; },
/* harmony export */   "Xg": function() { return /* binding */ convertJobSearchQueryToJobAlertQuery; },
/* harmony export */   "hX": function() { return /* binding */ generateJobListingsUrlObject; },
/* harmony export */   "l7": function() { return /* binding */ getJobAlertQueryDisplayValues; },
/* harmony export */   "pE": function() { return /* binding */ generateJobListTrackingDetails; },
/* harmony export */   "wZ": function() { return /* binding */ generateJobDetailsURL; }
/* harmony export */ });
/* unused harmony exports generateJobListingUrlsForSitemap, generateJobListingsURL, parseQueryForGetJobs, extractPerfectlyMatchingResults, extractSimilarJobs */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70930);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78219);
/* harmony import */ var _utils_jobLocationsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29749);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var constants_path__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96703);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var to_case__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var to_case__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(to_case__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _appServerConfig__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53813);
/* harmony import */ var _appServerConfig__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_appServerConfig__WEBPACK_IMPORTED_MODULE_9__);













/**
 * Generates the job listing urls for sitemap in the SEO friendly way
 * @returns array of strings - urls
 * @throws error if exception - calling method to handle it
 */ var generateJobListingUrlsForSitemap = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var jobListingUrls, api, ref, grades, gradeSpecialities, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, gradeSpeciality, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, speciality;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jobListingUrls = [];
                    api = axios__WEBPACK_IMPORTED_MODULE_3___default().create({
                        baseURL: _appServerConfig__WEBPACK_IMPORTED_MODULE_9__.appServerConfig.recruitApiUrl
                    });
                    return [
                        4,
                        api.get("/v1/picklist/grades")
                    ];
                case 1:
                    ref = _state.sent(), grades = ref.data;
                    grades = grades.filter(function(item) {
                        return item.key !== "Medical Student";
                    });
                    return [
                        4,
                        Promise.all(grades.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(grade) {
                                var ref, specialties;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                api.get("/v1/picklist/".concat(encodeURIComponent(grade.key), "/specialities"))
                                            ];
                                        case 1:
                                            ref = _state.sent(), specialties = ref.data;
                                            return [
                                                2,
                                                {
                                                    grade: grade.key,
                                                    specialties: specialties
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(grade) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    gradeSpecialities = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = gradeSpecialities[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            gradeSpeciality = _step.value;
                            jobListingUrls.push(generateJobListingsURL(gradeSpeciality.grade));
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = gradeSpeciality.specialties[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    speciality = _step1.value;
                                    jobListingUrls.push(generateJobListingsURL(gradeSpeciality.grade, speciality.key));
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        jobListingUrls
                    ];
            }
        });
    });
    return function generateJobListingUrlsForSitemap() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Generates the jobs listing pathname
 *
 * @param grade
 * @param speciality
 * @param rootSpeciality root speciality which is used when feature flag is on
 * @param subspeciality sub speciality which is used when feature flag is on
 * @returns string with format /jobs/listing/${grade}/${speciality}
 */ var generateJobListingsURL = function(grade, speciality, rootSpeciality, subspeciality) {
    if (!grade) {
        return "".concat(constants_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.JOBSLIST */ .m.JOBSLIST);
    }
    var jobListingBaseUrl = "".concat(constants_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.JOBSLISTSEO */ .m.JOBSLISTSEO, "/");
    if (grade) {
        jobListingBaseUrl += "".concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(grade.toLowerCase()), "/");
    }
    if (speciality) {
        jobListingBaseUrl += "".concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(speciality.toLowerCase()), "/");
    }
    if (rootSpeciality) {
        jobListingBaseUrl += "".concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(rootSpeciality.toLowerCase()), "/");
    }
    if (subspeciality) {
        jobListingBaseUrl += "".concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(subspeciality.toLowerCase()), "/");
    }
    return jobListingBaseUrl;
// if (grade && speciality) {
//   return `${PATH.JOBSLISTSEO}/${slug(grade.toLowerCase())}/${slug(speciality.toLowerCase())}`;
// }
// if (grade) {
//   return `${PATH.JOBSLISTSEO}/${slug(grade.toLowerCase())}`;
// }
};
function objectEntries(obj) {
    return Object.entries(obj);
}
/**
 *  Remove params from the query string if they:
 *  - are falsy: undefined, null etc.
 *  - have 'none' as value: could come from form controls like grade, specialty, date
 *  - have 'listing' as key: could come from /jobs/listing/<grade>/<specialty> route as a param
 */ function purgeQuery(query) {
    var purgedQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, query);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = objectEntries(query)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (!value || value === "none" || key === "listing") {
                delete purgedQuery[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return purgedQuery;
}
/**
 * Generates the jobs listing url object
 *
 * @param query
 * @returns UrlObject
 */ var generateJobListingsUrlObject = function(query) {
    var purgedQuery = purgeQuery(query);
    var speciality = purgedQuery.speciality, grade = purgedQuery.grade, rootSpeciality = purgedQuery.rootSpeciality, subspeciality = purgedQuery.subspeciality, locationName = purgedQuery.locationName, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(purgedQuery, [
        "speciality",
        "grade",
        "rootSpeciality",
        "subspeciality",
        "locationName"
    ]);
    var newQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, rest);
    if (locationName) {
        newQuery.locationName = locationName;
    } else {
        // generate locationName if missing
        var displayName = (0,_utils_jobLocationsHelper__WEBPACK_IMPORTED_MODULE_2__/* .generateLocationNameFromLocationString */ .q2)(purgedQuery.location);
        if (displayName) {
            newQuery.locationName = displayName;
        }
    }
    return {
        pathname: generateJobListingsURL(grade, speciality, rootSpeciality, subspeciality),
        query: newQuery
    };
};
/**
 * Generates the root-relative jobs details URL. The result is in one of the following formats
 * /jobs/grade/speciality/jnxxxxxxxx
 * /jobs/grade/jnxxxxxxxx
 * /jobs/jnxxxxxxxx
 *
 * @param jobNumber the human friendly job reference number from Salesforce
 * @param grade the grade the job is for, if any
 * @param speciality the specialty the job is for, if any
 * @returns the canonical URL for rendering the job page
 */ var generateJobDetailsURL = function(jobNumber, grade, speciality) {
    if (grade && speciality && jobNumber) {
        return "".concat(constants_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.JOBS */ .m.JOBS, "/").concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(grade.toLowerCase()), "/").concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(speciality.toLowerCase()), "/").concat(jobNumber.toLowerCase());
    }
    if (grade && jobNumber) {
        return "".concat(constants_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.JOBS */ .m.JOBS, "/").concat((0,to_case__WEBPACK_IMPORTED_MODULE_6__.slug)(grade.toLowerCase()), "/").concat(jobNumber.toLowerCase());
    }
    if (jobNumber) {
        return "".concat(constants_path__WEBPACK_IMPORTED_MODULE_4__/* .PATH.JOBS */ .m.JOBS, "/").concat(jobNumber.toLowerCase());
    }
    return "";
};
var generateJobListTrackingDetails = function(queryData, user) {
    return {
        logged_in: user ? true : false,
        grade: queryData["grade"],
        speciality: queryData["speciality"],
        work_type: queryData["workType"],
        start_date: queryData["startDate"],
        end_date: queryData["endDate"],
        keywords: queryData["keywords"],
        location: queryData["location"]
    };
};
/**
 * Generate location info
 * @param city
 * @param locationDisplay
 * @param country
 * @returns
 */ var generateLocationInfo = function(locationDisplay, country, city) {
    var countryDetails = country ? " ".concat(country) : "";
    if (city) {
        return "".concat(city, ", ").concat(locationDisplay).concat(countryDetails);
    }
    return "".concat(locationDisplay).concat(countryDetails);
};
/**
 *  Clean up search query data for job alerts use
 */ var jobAlertQueryParams = new Set([
    "grade",
    "speciality",
    "rootSpeciality",
    "subspeciality",
    "location",
    "workType",
    "startDate",
    "endDate",
    "keywords", 
]);
function convertJobSearchQueryToJobAlertQuery(query) {
    var newQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, query);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(newQuery)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_step.value, 1), key = _value[0];
            if (!jobAlertQueryParams.has(key)) {
                delete newQuery[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (query.location) {
        newQuery.location = (0,_utils_jobLocationsHelper__WEBPACK_IMPORTED_MODULE_2__/* .convertLocationsToValues */ .AV)(newQuery.location);
    }
    if (newQuery.grade === "none") {
        delete newQuery.grade;
    }
    return newQuery;
}
/**
 *  Convert Job Alert query params into displayable strings
 */ function getJobAlertQueryDisplayValues(query) {
    var list = [];
    if (query === null || query === void 0 ? void 0 : query.keywords) {
        list.push(query.keywords);
    }
    if (query === null || query === void 0 ? void 0 : query.location) {
        var arrayLocations = (0,_utils_jobLocationsHelper__WEBPACK_IMPORTED_MODULE_2__/* .convertLocationStringToLocationDisplayList */ .gg)(query.location);
        list.push(arrayLocations.join(", "));
    } else {
        list.push(_constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_LOCATIONS */ .ZY);
    }
    if (query === null || query === void 0 ? void 0 : query.grade) {
        list.push(query.grade);
    }
    if (query === null || query === void 0 ? void 0 : query.speciality) {
        list.push(query.speciality);
    }
    if (query === null || query === void 0 ? void 0 : query.rootSpeciality) {
        list.push(query.rootSpeciality);
    }
    if (query === null || query === void 0 ? void 0 : query.subspeciality) {
        list.push(query.subspeciality);
    }
    if (query === null || query === void 0 ? void 0 : query.workType) {
        list.push(query.workType);
    }
    if ((query === null || query === void 0 ? void 0 : query.startDate) || (query === null || query === void 0 ? void 0 : query.endDate)) {
        var dateTagFormat = "DD/MM/YYYY";
        var endD = (query === null || query === void 0 ? void 0 : query.endDate) ? " ~ ".concat(dayjs__WEBPACK_IMPORTED_MODULE_5___default()(query === null || query === void 0 ? void 0 : query.endDate).format(dateTagFormat)) : "";
        var startD = (query === null || query === void 0 ? void 0 : query.startDate) ? "".concat(dayjs__WEBPACK_IMPORTED_MODULE_5___default()(query === null || query === void 0 ? void 0 : query.startDate).format(dateTagFormat)) : "NOW";
        list.push("".concat(startD).concat(endD));
    }
    return list;
}
// Removes 'amp;' from misencoded url keys that start with 'amp;'
var stripAmpFromKeys = function(query) {
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(query)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            if (key.startsWith("amp;")) {
                var newKey = key.slice(4);
                output[newKey] = value;
            } else {
                output[key] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
};
var parseQueryForGetJobs = function(query) {
    var convertedQuery = _object_spread({}, stripAmpFromKeys(query));
    // reduce noise from page parameter attacks
    if (convertedQuery.page && typeof convertedQuery.page === "string") {
        var sanitizedPage = convertedQuery.page.replace(/\D/g, "");
        var parsedPage = parseInt(sanitizedPage, 10); // can return a NAN so check below
        convertedQuery.page = !isNaN(parsedPage) && sanitizedPage !== "" ? String(parsedPage) : "1";
    }
    if (convertedQuery.location) {
        convertedQuery.location = convertLocationsToValues(convertedQuery.location);
    }
    if (convertedQuery.startDate) {
        var ref;
        convertedQuery.startDate = (ref = parseAndFormatDate(convertedQuery.startDate, "YYYY-MM-DD")) !== null && ref !== void 0 ? ref : undefined;
    }
    if (convertedQuery.endDate) {
        var ref1;
        convertedQuery.endDate = (ref1 = parseAndFormatDate(convertedQuery.endDate, "YYYY-MM-DD")) !== null && ref1 !== void 0 ? ref1 : undefined;
    }
    if (convertedQuery.rootSpeciality) {
        convertedQuery.speciality = convertedQuery.rootSpeciality;
        convertedQuery.rootSpeciality = undefined;
    }
    return convertedQuery;
};
var extractPerfectlyMatchingResults = function(jobs) {
    var perfectlyMatchingJobs = jobs.data.filter(function(job) {
        return !job.matched || job.matched.partial === false;
    });
    var perfectJobResults = {
        limit: jobs.limit,
        page: jobs.page,
        total: jobs.total,
        data: perfectlyMatchingJobs
    };
    return perfectJobResults;
};
var extractSimilarJobs = function(jobs) {
    var similarJobs = jobs.filter(function(job) {
        return job.matched && job.matched.partial === true;
    });
    return similarJobs;
};


/***/ }),

/***/ 29749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ convertLocationsToValues; },
/* harmony export */   "gg": function() { return /* binding */ convertLocationStringToLocationDisplayList; },
/* harmony export */   "q2": function() { return /* binding */ generateLocationNameFromLocationString; }
/* harmony export */ });
/* unused harmony export convertLocationDisplayListToLocationString */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70930);


var convertLocationDisplayListToLocationString = function(locationDisplayValues) {
    var locationValues = _to_consumable_array(locationDisplayValues);
    // replace group names with values
    if (locationDisplayValues.indexOf(ALL_LOCATIONS) >= 0) {
        locationValues = [];
    } else {
        Object.keys(LOCATIONS).forEach(function(key) {
            if (key !== ALL_LOCATIONS && locationValues.indexOf(key) >= 0) {
                locationValues.splice(locationValues.indexOf(key), 1);
                var subItems = LOCATIONS[key].map(function(item) {
                    return item.value;
                });
                locationValues = _to_consumable_array(locationValues).concat(_to_consumable_array(subItems));
            }
        });
    }
    // replace individual names with values
    var mappedLocationValues = locationValues.map(function(label) {
        return LOCATIONS_LABEL_TO_VALUE_MAP.get(label) || label;
    });
    return mappedLocationValues.join(";");
};
var isAllSelected = function(selectedLocations, groupName) {
    var allSelected = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm[groupName][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (selectedLocations.indexOf(item.value) < 0) {
                allSelected = false;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return allSelected;
};
function convertLocationStringToLocationDisplayList(location) {
    // if 'All Locations' is selected
    if (!location) {
        return [];
    }
    var previousLocationValues = location.split(";");
    var displayValues = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(previousLocationValues);
    Object.keys(_constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm).forEach(function(key) {
        if (key !== _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_LOCATIONS */ .ZY) {
            var allSelected = isAllSelected(displayValues, key);
            // if all sub items are selected, then remove sub items and add the group name
            if (allSelected) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm[key][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        displayValues.splice(displayValues.indexOf(item.value), 1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                displayValues = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(displayValues).concat([
                    key
                ]);
            }
            if (key === _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_NEW_ZEALAND */ .rb) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm[key][Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var item1 = _step1.value;
                        if (displayValues.indexOf(item1.value) >= 0) {
                            displayValues.splice(displayValues.indexOf(item1.value), 1, item1.label);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    });
    return displayValues;
}
/**
 * Converts front end location data to back end location data
 */ var convertLocationsToValues = function(location) {
    if (location) {
        var locationLabels = location.split(";");
        Object.keys(_constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm).forEach(function(key) {
            if (key === _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_NEW_ZEALAND */ .rb) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .LOCATIONS */ .Lm[key][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        if (locationLabels.indexOf(item.label) >= 0) {
                            locationLabels.splice(locationLabels.indexOf(item.label), 1, item.value);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
        return locationLabels.join(";");
    }
    return "";
};
/**
 *  Generate location name from location string:
 */ function generateLocationNameFromLocationString(location) {
    if (!location) {
        return "";
    }
    var displayName = convertLocationStringToLocationDisplayList(convertLocationsToValues(location))[0];
    // remove 'All' prefixes for AU and NZ
    if (displayName === _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_NEW_ZEALAND */ .rb) {
        displayName = "New Zealand";
    }
    if (displayName === _constants_jobLocations__WEBPACK_IMPORTED_MODULE_0__/* .ALL_AUSTRALIA */ .g6) {
        displayName = "Australia";
    }
    return displayName;
}


/***/ })

}]);